
export const userConnectButton = {
  fontSize: '0.875rem',
  borderRadius: 'full',
  border: '1px solid #393E46',
  backgroundColor: '#393E46',
  color: '#FFFFFF',
  ':disabled': {
    backgroundColor: '#33373f'
  },
  ':disabled:hover': {
    backgroundColor: '#33373f'
  },
  ':active': {
    backgroundColor: '#696e75',
  },
  ':hover': {
    backgroundColor: '#595E66',
  },
  ':focus': {
    boxShadow: 'none',
  },
}